/* Behaviour for the cro-* sections: trust strip, photo gallery, pack selection, delivery dates, sticky bar, branch slider, deferred maps and photos. */
(function () {
  if (window.__croLoaded) return;
  window.__croLoaded = true;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function pkNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Karachi', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false })
      .formatToParts(new Date())
      .forEach(function (p) { parts[p.type] = p.value; });
    return { day: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour % 24 };
  }
  /* Working days are Monday to Saturday. */
  function addWorkingDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (d.getUTCDay() !== 0) n--;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  }
  /* Index of the slide nearest the left edge of a horizontal scroller. */
  function nearest(track) {
    var best = 0;
    var gap = Infinity;
    for (var i = 0; i < track.children.length; i++) {
      var d = Math.abs(track.children[i].offsetLeft - track.scrollLeft);
      if (d < gap) { gap = d; best = i; }
    }
    return best;
  }
  function onScrollFrame(el, fn) {
    var ticking = false;
    el.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; fn(); });
    }, { passive: true });
  }
  /* Calls fn(until) whenever the shopper touches the scroller, so auto-scroll can wait. */
  function onTouch(el, fn) {
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (name) {
      el.addEventListener(name, fn, { passive: true });
    });
  }

  function initBuybox(root) {
    if (root.getAttribute('data-cro-ready')) return;
    root.setAttribute('data-cro-ready', '1');

    /* trust strip: one message at a time on phones, swipeable, moving on by itself */
    var strip = root.querySelector('[data-cro-strip]');
    if (strip && strip.children.length > 1 && !reduceMotion) {
      var stripWait = 0;
      onTouch(strip, function () { stripWait = Date.now() + 6000; });
      window.setInterval(function () {
        if (strip.scrollWidth <= strip.clientWidth + 1 || document.hidden || Date.now() < stripWait) return;
        var i = nearest(strip) + 1;
        if (i >= strip.children.length) i = 0;
        strip.scrollTo({ left: strip.children[i].offsetLeft, behavior: 'smooth' });
      }, 3000);
    }

    /* photo gallery */
    var track = root.querySelector('[data-cro-track]');
    if (track && track.children.length > 1) {
      var slides = track.children;
      var count = root.querySelector('[data-cro-count]');
      var current = 0;
      var go = function (i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      };
      onScrollFrame(track, function () {
        current = nearest(track);
        if (count) count.textContent = current + 1 + ' / ' + slides.length;
      });
      var galleryWait = 0;
      var hold = function () { galleryWait = Date.now() + 8000; };
      var prev = root.querySelector('[data-cro-prev]');
      var next = root.querySelector('[data-cro-next]');
      if (prev) prev.addEventListener('click', function () { hold(); go(current - 1); });
      if (next) next.addEventListener('click', function () { hold(); go(current + 1); });

      /* auto-scroll: waits while the shopper is swiping, hovering, or the photos are off screen */
      var every = parseInt(track.getAttribute('data-autoplay'), 10) || 0;
      if (every > 0 && !reduceMotion) {
        var inView = true;
        var hovering = false;
        onTouch(track, hold);
        track.addEventListener('mouseenter', function () { hovering = true; });
        track.addEventListener('mouseleave', function () { hovering = false; });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(track);
        }
        window.setInterval(function () {
          if (!inView || hovering || document.hidden || Date.now() < galleryWait) return;
          go(current + 1 >= slides.length ? 0 : current + 1);
        }, every * 1000);
      }
    }

    /* pack selection */
    var idInput = root.querySelector('[data-cro-id]');
    var set = function (sel, text) {
      var nodes = root.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) nodes[i].textContent = text;
    };
    var apply = function (input) {
      var d = input.dataset;
      if (idInput) idInput.value = input.value;
      set('[data-cro-price]', d.price);
      set('[data-cro-sub]', d.title + ' · ' + d.price + ' · ' + d.ship);
      set('[data-cro-sticky-sub]', d.title + ' · ' + d.ship);
      var was = root.querySelector('[data-cro-compare]');
      var save = root.querySelector('[data-cro-save]');
      if (was) { was.textContent = d.compare || ''; was.hidden = !d.compare; }
      if (save) { save.textContent = d.save ? 'Save ' + d.save : ''; save.hidden = !d.save; }
    };
    var radios = root.querySelectorAll('[data-cro-pack]');
    var checked = function () {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
      return null;
    };
    for (var r = 0; r < radios.length; r++) {
      radios[r].addEventListener('change', function (e) {
        apply(e.target);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', e.target.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    }
    if (checked()) apply(checked());
    /* make sure the cart always gets the pack that is selected on screen */
    var form = idInput && idInput.form;
    if (form) {
      form.addEventListener('submit', function () {
        var c = checked();
        if (c) idInput.value = c.value;
      }, true);
    }

    /* delivery dates */
    var del = root.querySelector('[data-cro-delivery]');
    if (del) {
      try {
        var now = pkNow();
        var cutoff = parseInt(del.getAttribute('data-cutoff'), 10) || 15;
        var min = parseInt(del.getAttribute('data-min'), 10) || 3;
        var max = parseInt(del.getAttribute('data-max'), 10) || 5;
        var start = now.day;
        if (start.getUTCDay() === 0 || now.hour >= cutoff) start = addWorkingDays(start, 1);
        var khi = del.querySelector('[data-cro-khi]');
        var pk = del.querySelector('[data-cro-pk]');
        if (khi) khi.textContent = ', expected by ' + fmt(addWorkingDays(start, 1));
        if (pk) pk.textContent = ', expected ' + fmt(addWorkingDays(start, min)) + ' to ' + fmt(addWorkingDays(start, max));
      } catch (err) { /* dates are an enhancement; the static text still shows */ }
    }

    /* sticky bar: always on, or shown once the main button has scrolled out of view above */
    var bar = root.querySelector('[data-cro-sticky]');
    var main = root.querySelector('[data-cro-main-cta]');
    if (bar) {
      bar.hidden = false;
      var always = bar.getAttribute('data-mode') === 'always' || !main;
      var shown = null;
      var queued = false;
      var check = function () {
        queued = false;
        var on = always || main.getBoundingClientRect().bottom < 0;
        if (on !== shown) {
          shown = on;
          bar.classList.toggle('is-on', on);
        }
        document.documentElement.style.setProperty('--cro-sticky-pad', on ? bar.offsetHeight + 'px' : '0px');
      };
      var onScroll = function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(check);
      };
      if (!always) window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      check();
    }
  }

  /* swipeable cards with previous/next buttons and a "1 / 2" counter (shop locations) */
  function initSlider(root) {
    if (root.getAttribute('data-cro-ready')) return;
    root.setAttribute('data-cro-ready', '1');
    var track = root.querySelector('[data-cro-slider-track]');
    if (!track) return;
    var prev = root.querySelector('[data-cro-slider-prev]');
    var next = root.querySelector('[data-cro-slider-next]');
    var count = root.querySelector('[data-cro-slider-count]');
    var n = track.children.length;
    var current = 0;
    var sync = function () {
      current = nearest(track);
      if (count) count.textContent = current + 1 + ' / ' + n;
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === n - 1;
    };
    var go = function (i) {
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: track.children[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    onScrollFrame(track, sync);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    sync();
  }

  /* Maps and review photos get their source once their section is close to the screen.
     Everything in the section loads together, so cards further along a swipe row are ready too. */
  function initDefer(root) {
    if (root.getAttribute('data-cro-defer') === 'done') return;
    var nodes = root.querySelectorAll('[data-cro-src]');
    var finish = function () {
      root.setAttribute('data-cro-defer', 'done');
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
    var check = function () {
      var top = root.getBoundingClientRect().top;
      var view = window.innerHeight || document.documentElement.clientHeight;
      if (top > view + 900) return;
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].setAttribute('src', nodes[i].getAttribute('data-cro-src'));
        nodes[i].removeAttribute('data-cro-src');
      }
      finish();
    };
    if (!nodes.length) { finish(); return; }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  function boot(scope) {
    var i;
    var boxes = (scope || document).querySelectorAll('[data-cro-buybox]');
    for (i = 0; i < boxes.length; i++) initBuybox(boxes[i]);
    var sliders = (scope || document).querySelectorAll('[data-cro-slider]');
    for (i = 0; i < sliders.length; i++) initSlider(sliders[i]);
    var deferred = (scope || document).querySelectorAll('[data-cro-defer]');
    for (i = 0; i < deferred.length; i++) initDefer(deferred[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
